'use client';

export default function StackedProgress({
  className,
  totalSupply,
  allocations,
  pctComplete,
  preallocated = 0,
}) {
  const preallocatedPct = Math.round((preallocated / totalSupply) * 100);
  return (
    <div className={className}>
      <div className="relative w-full">
        <div className="overflow-hidden h-2 mb-4 text-xs flex bg-neutral-200">
          <div
            style={{ left: 0, width: `${preallocatedPct}%` }}
            className="absolute h-2 shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-base-300"
          >
            <div
              className="tooltip tooltip-bottom"
              data-tip={`Preallocated Supply: ${preallocated}`}
            >
              <div className="h-4 w-full cursor-pointer" />
            </div>
          </div>
          {allocations.map((a) => {
            const { title, size, from } = a;
            const offset = preallocatedPct + Math.round(((from || 0) / totalSupply) * 100);
            const width = size ? Math.round((size / totalSupply) * 100) : 0;
            const style = {
              left: `${offset}%`,
              width: `${Math.min(width, 100 - offset)}.1%`,
            };

            return (
              <div
                key={title}
                style={style}
                className={`absolute h-2 shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center ${a.classes}`}
              >
                <div className="tooltip tooltip-bottom" data-tip={`${title}: ${size}`}>
                  <div className="h-4 w-full cursor-pointer" />
                </div>
              </div>
            );
          })}
          {pctComplete < 100 ? (
            <div
              className="absolute h-2 flex flex-col justify-center bg-neutral-200"
              style={{
                zIndex: 1,
                width: `${100 - pctComplete}%`,
                left: `${pctComplete}%`,
              }}
            >
              <div className="tooltip tooltip-bottom" data-tip="Remaining Supply">
                <div className="h-4 w-full cursor-pointer" />
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
